(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  };

  ready(() => {
    const root = document.querySelector('[data-prema-v6]');
    const dataNode = document.getElementById('PremaV6Data');
    if (!root || !dataNode || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    let data;
    try { data = JSON.parse(dataNode.textContent); }
    catch (error) { console.error('Prema V6 product data could not be read.', error); return; }

    const $ = (selector, scope = document) => scope.querySelector(selector);
    const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
    const variantById = new Map(data.variants.map((variant) => [String(variant.id), variant]));
    const variantByName = new Map(data.variants.map((variant) => [variant.name, variant]));
    const form = $('#PremaV6ProductForm');
    const nativeSelect = $('#PremaV6Variant');
    const quantity = $('#PremaV6Quantity');
    const addButton = $('#PremaV6Add');
    const errorNode = $('#PremaV6Error');
    const confirmation = $('#PremaV6CartConfirmation');
    const cartMessage = $('#PremaV6CartMessage');
    const listbox = $('#visualColorListbox');
    const listboxTrigger = $('#visualColorTrigger');
    let lastModalTrigger = null;
    let activeModal = null;
    let modalVariant = null;
    let reviewIndex = 0;
    let showSelectedVariantInHero = () => {};

    const FAMILY_RULES = [
      ['Neutrals', ['white', 'cream', 'beige', 'tan', 'bronze', 'brown', 'mocha', 'champagne', 'nude', 'pewter', 'black', 'grey', 'gray', 'gold', 'buttecream']],
      ['Blues & Teals', ['blue', 'navy', 'teal', 'turquoise', 'robin', 'peacock', 'seafoam', 'denim', 'glacier', 'slate']],
      ['Greens', ['green', 'sage', 'pine', 'emerald', 'chartreuse', 'moss', 'olive', 'forest']],
      ['Purples', ['purple', 'plum', 'wine', 'periwinkle', 'lilac']],
      ['Pinks', ['pink', 'blush', 'ballerina', 'fuchsia', 'rose', 'coral']],
      ['Reds & Warm', ['red', 'burgundy', 'crimson', 'fire', 'orange', 'rust', 'yellow']]
    ];

    const familyFor = (variant) => {
      const name = variant.name.toLowerCase();
      for (const [family, words] of FAMILY_RULES) if (words.some((word) => name.includes(word))) return family;
      return 'Neutrals';
    };
    const variantsForFamily = (name) => data.variants.filter((variant) => familyFor(variant) === name);

    let selected = (() => {
      const urlId = new URL(location.href).searchParams.get('variant');
      return variantById.get(urlId) || variantById.get(nativeSelect?.value) || data.variants.find((variant) => variant.available) || data.variants[0];
    })();
    let hasExplicitSelection = new URL(location.href).searchParams.has('variant');

    function makeSwatch(variant) {
      const swatch = document.createElement('span');
      swatch.className = 'fabric-swatch';
      swatch.dataset.num = variant.name.split(' ')[0];
      const image = document.createElement('img');
      image.src = variant.swatch;
      image.alt = '';
      image.loading = 'lazy';
      image.width = 80;
      image.height = 80;
      swatch.append(image);
      return swatch;
    }

    function makeColorButton(variant, className, behavior = 'select') {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = className;
      button.dataset.name = variant.name;
      button.dataset.variantId = variant.id;
      const label = document.createElement('span');
      label.textContent = variant.name + (variant.available ? '' : ' · Sold out');
      button.append(makeSwatch(variant), label);
      if (behavior === 'preview') button.addEventListener('click', () => openColorModal(variant, button));
      else button.addEventListener('click', () => chooseVariant(variant, true, className === 'family-shade'));
      return button;
    }

    function renderHero() {
      const stage = $('#heroStage');
      const main = $('#mainImg');
      const thumbs = $('#heroThumbs');
      const status = $('#galleryStatus');
      if (!main || !thumbs || !data.hero?.length) return;
      thumbs.innerHTML = '';
      let imageRequest = 0;
      const selectedButton = document.createElement('button');
      selectedButton.type = 'button';
      selectedButton.className = 'selected-color-thumb';
      const selectedImage = document.createElement('img');
      selectedImage.alt = '';
      selectedImage.width = 128;
      selectedImage.height = 160;
      selectedButton.append(selectedImage);
      thumbs.append(selectedButton);

      const markActive = (activeButton) => {
        $$('button', thumbs).forEach((button) => button.classList.toggle('active', button === activeButton));
      };
      const show = (item, activeButton) => {
        imageRequest += 1;
        main.src = item.src;
        main.alt = item.alt;
        main.classList.toggle('landscape', item.fit === 'cover');
        main.classList.remove('is-loading');
        stage?.style.setProperty('--hero-bg', `url("${item.src.replace(/"/g, '%22')}")`);
        if (status) status.textContent = item.label;
        markActive(activeButton);
      };
      data.hero.forEach((item, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', item.label);
        const image = document.createElement('img');
        image.src = item.src;
        image.alt = '';
        image.loading = index < 2 ? 'eager' : 'lazy';
        image.width = 128;
        image.height = 160;
        button.append(image);
        button.addEventListener('click', () => show(item, button));
        thumbs.append(button);
      });
      showSelectedVariantInHero = (variant) => {
        const src = variant.image || variant.swatch;
        const alt = `${variant.name} Prema Poncho product view`;
        const label = `Selected color · ${variant.name}`;
        const request = ++imageRequest;
        selectedImage.src = src;
        selectedButton.setAttribute('aria-label', label);
        selectedButton.onclick = () => showSelectedVariantInHero(variant);
        main.classList.add('is-loading');
        markActive(selectedButton);
        if (status) status.textContent = label;
        const preload = new Image();
        preload.onload = () => {
          if (request !== imageRequest || String(selected.id) !== String(variant.id)) return;
          main.src = src;
          main.alt = alt;
          main.classList.remove('landscape', 'is-loading');
          stage?.style.setProperty('--hero-bg', `url("${src.replace(/"/g, '%22')}")`);
          markActive(selectedButton);
        };
        preload.onerror = () => {
          if (request !== imageRequest) return;
          main.classList.remove('is-loading');
        };
        preload.src = src;
      };
      show(data.hero[0], thumbs.children[1]);
    }

    function updateSelectionUI(announce = false, showConfirmation = false, showVariantImage = true) {
      $('#colorName').textContent = selected.name;
      $('#visualColorValue').textContent = selected.name;
      $('#PremaV6Price').textContent = selected.formattedPrice;
      $('#PremaV6StickyPrice').textContent = selected.available ? selected.formattedPrice : 'Sold Out';
      $('#PremaV6StickyColor').textContent = selected.name;
      nativeSelect.value = String(selected.id);
      if (showVariantImage) showSelectedVariantInHero(selected);
      const triggerSwatch = $('#visualTriggerSwatch');
      triggerSwatch.innerHTML = '';
      triggerSwatch.append(makeSwatch(selected));
      const availability = $('#PremaV6Availability');
      availability.textContent = selected.available ? `${selected.name} is available.` : `${selected.name} is currently sold out.`;
      availability.dataset.state = selected.available ? 'available' : 'sold-out';
      addButton.disabled = !selected.available;
      addButton.textContent = selected.available ? `Add to Cart — ${selected.formattedPrice}` : 'Sold Out';
      $$('.overview-swatch,.family-shade,.visual-option').forEach((button) => {
        const active = String(button.dataset.variantId) === String(selected.id);
        button.setAttribute(button.classList.contains('visual-option') ? 'aria-selected' : 'aria-pressed', String(active));
      });
      $$('.family-card').forEach((button) => button.classList.toggle('active', button.dataset.family === familyFor(selected)));
      $$('.family-tab').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.family === familyFor(selected))));
      $$('[data-pv6-dynamic-cta]').forEach((button) => {
        button.textContent = !hasExplicitSelection
          ? 'Choose Your Color'
          : selected.available ? `Shop ${selected.name}` : 'Choose Another Color';
      });
      const stickyButton = $('#PremaV6Sticky [data-pv6-scroll-buy]');
      if (stickyButton) {
        stickyButton.textContent = !hasExplicitSelection
          ? 'Choose Your Color'
          : selected.available ? `Shop ${selected.name}` : 'Choose Another Color';
      }
      const selectionConfirmation = $('#colorSelectionConfirmation');
      if (showConfirmation && selectionConfirmation) {
        $('#colorSelectionMessage').textContent = `${selected.name} selected${selected.available ? '' : ' — currently sold out'}`;
        selectionConfirmation.hidden = false;
      }
      if (announce) {
        const toast = $('#toast');
        toast.textContent = `${selected.name} selected${selected.available ? '' : ' — sold out'}.`;
        toast.classList.add('show');
        setTimeout(() => toast.classList.remove('show'), 1800);
      }
    }

    function chooseVariant(variant, announce = false, showConfirmation = false, explicitSelection = true) {
      if (!variant) return;
      selected = variant;
      if (explicitSelection) hasExplicitSelection = true;
      confirmation.hidden = true;
      errorNode.textContent = '';
      nativeSelect.value = String(variant.id);
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant } }));
      renderFamilyTabs();
      updateSelectionUI(announce, showConfirmation);
    }

    function renderFamilyTabs() {
      const container = $('#purchaseFamilyTabs');
      if (!container) return;
      container.innerHTML = '';
      const all = document.createElement('button');
      all.type = 'button';
      all.className = 'family-tab';
      all.textContent = 'See All';
      all.setAttribute('aria-pressed', 'false');
      all.addEventListener('click', () => openModal($('#allColorsModal'), all));
      container.append(all);
      FAMILY_RULES.forEach(([family]) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'family-tab';
        button.dataset.family = family;
        button.textContent = family;
        button.setAttribute('aria-pressed', String(familyFor(selected) === family));
        button.addEventListener('click', () => openFamilyModal(family, button));
        container.append(button);
      });
    }

    function renderListbox() {
      listbox.innerHTML = '';
      data.variants.forEach((variant) => {
        const button = makeColorButton(variant, 'visual-option');
        button.setAttribute('role', 'option');
        button.setAttribute('aria-selected', String(variant.id === selected.id));
        button.addEventListener('click', () => closeListbox(true));
        listbox.append(button);
      });
    }

    function openListbox() {
      listbox.hidden = false;
      listboxTrigger.setAttribute('aria-expanded', 'true');
      const active = listbox.querySelector(`[data-variant-id="${selected.id}"]`) || listbox.firstElementChild;
      active?.focus();
    }
    function closeListbox(focusTrigger = false) {
      listbox.hidden = true;
      listboxTrigger.setAttribute('aria-expanded', 'false');
      if (focusTrigger) listboxTrigger.focus();
    }
    listboxTrigger?.addEventListener('click', () => listbox.hidden ? openListbox() : closeListbox());
    listbox?.addEventListener('keydown', (event) => {
      const options = $$('.visual-option', listbox);
      const index = options.indexOf(document.activeElement);
      if (event.key === 'Escape') { event.preventDefault(); closeListbox(true); }
      if (event.key === 'ArrowDown') { event.preventDefault(); options[(index + 1) % options.length]?.focus(); }
      if (event.key === 'ArrowUp') { event.preventDefault(); options[(index - 1 + options.length) % options.length]?.focus(); }
      if (event.key === 'Home') { event.preventDefault(); options[0]?.focus(); }
      if (event.key === 'End') { event.preventDefault(); options.at(-1)?.focus(); }
    });

    function renderFamilyGallery() {
      const gallery = $('#familyGallery');
      if (!gallery) return;
      gallery.innerHTML = '';
      FAMILY_RULES.forEach(([family]) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'family-card';
        button.dataset.family = family;
        button.setAttribute('aria-label', `View ${family} colors`);
        const image = document.createElement('img');
        image.src = data.familyBoards[family];
        image.alt = `${family} Prema Poncho color board`;
        image.loading = 'lazy';
        const copy = document.createElement('span');
        copy.innerHTML = `<b>${family}</b><small>${variantsForFamily(family).length} current shades</small><em>View these colors</em>`;
        button.append(image, copy);
        button.addEventListener('click', () => openFamilyModal(family, button));
        gallery.append(button);
      });
    }

    function renderOverview() {
      const grid = $('#interactiveColorGrid');
      const allOptions = $('#allColorOptions');
      if (grid) {
        grid.innerHTML = '';
        data.variants.forEach((variant) => {
          const button = makeColorButton(variant, 'overview-swatch', 'preview');
          button.setAttribute('aria-pressed', String(variant.id === selected.id));
          grid.append(button);
        });
      }
      if (allOptions) {
        allOptions.innerHTML = '';
        data.variants.forEach((variant) => {
          const button = makeColorButton(variant, 'family-shade');
          button.setAttribute('aria-pressed', String(variant.id === selected.id));
          button.addEventListener('click', () => closeModal($('#allColorsModal')));
          allOptions.append(button);
        });
      }
    }
    function openModal(modal, trigger) {
      if (!modal) return;
      lastModalTrigger = trigger || document.activeElement;
      activeModal = modal;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      modal.querySelector('.modal-close')?.focus();
    }
    function closeModal(modal) {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      document.body.style.overflow = '';
      if (activeModal === modal) activeModal = null;
      const returnTarget = lastModalTrigger;
      lastModalTrigger = null;
      returnTarget?.focus?.();
    }

    function trapModalFocus(event) {
      if (event.key !== 'Tab' || !activeModal || activeModal.hidden) return;
      const focusable = $$('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])', activeModal)
        .filter((node) => !node.hidden && node.getAttribute('aria-hidden') !== 'true');
      if (!focusable.length) {
        event.preventDefault();
        activeModal.querySelector('[role="dialog"]')?.focus();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || !activeModal.contains(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !activeModal.contains(document.activeElement))) {
        event.preventDefault();
        first.focus();
      }
    }
    $$('[data-close-all-colors]').forEach((node) => node.addEventListener('click', () => closeModal($('#allColorsModal'))));
    $$('[data-close-family]').forEach((node) => node.addEventListener('click', () => closeModal($('#familyModal'))));
    $$('[data-close-modal]').forEach((node) => node.addEventListener('click', () => closeModal($('#colorModal'))));

    function openFamilyModal(family, trigger) {
      const modal = $('#familyModal');
      $('#familyModalTitle').textContent = family;
      const board = $('#familyBoardImage');
      board.src = data.familyBoards[family];
      board.alt = `${family} Prema Poncho color board`;
      const grid = $('#familyShadeGrid');
      grid.innerHTML = '';
      variantsForFamily(family).forEach((variant) => {
        const button = makeColorButton(variant, 'family-shade');
        button.setAttribute('aria-pressed', String(variant.id === selected.id));
        button.addEventListener('click', () => closeModal(modal));
        grid.append(button);
      });
      openModal(modal, trigger);
    }

    function openColorModal(variant, trigger) {
      modalVariant = variant;
      $('#modalColorName').textContent = variant.name;
      $('.modal-price').textContent = variant.formattedPrice;
      const image = $('#modalColorImage');
      image.src = variant.image || variant.swatch;
      image.alt = `${variant.name} Prema Poncho product view`;
      const selectButton = $('#modalSelect');
      selectButton.textContent = variant.available ? 'Select this color' : 'View sold-out color';
      const goTopButton = $('#modalGoTop');
      if (goTopButton) goTopButton.textContent = variant.available ? 'Go to purchase' : 'Go to color choices';
      openModal($('#colorModal'), trigger);
    }
    $('#modalSelect')?.addEventListener('click', () => { chooseVariant(modalVariant, true, true); closeModal($('#colorModal')); });
    $('#modalGoTop')?.addEventListener('click', () => { chooseVariant(modalVariant, true); closeModal($('#colorModal')); scrollToBuy(); });

    function scrollToBuy() {
      const selectionConfirmation = $('#colorSelectionConfirmation');
      if (selectionConfirmation) selectionConfirmation.hidden = true;
      const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      if (innerWidth > 700) {
        const price = $('#PremaV6Price');
        const header = $('#shopify-section-header');
        const sticky = $('#PremaV6Sticky');
        if (!price || !listboxTrigger || !addButton) return;
        const headerRect = header?.getBoundingClientRect();
        const stickyRect = sticky?.getBoundingClientRect();
        const headerStyle = header ? getComputedStyle(header) : null;
        const stickyStyle = sticky ? getComputedStyle(sticky) : null;
        const topObstruction = headerRect && ['fixed', 'sticky'].includes(headerStyle?.position) && headerRect.bottom > 0
          ? Math.max(0, headerRect.bottom)
          : 0;
        const bottomObstruction = stickyRect && stickyStyle?.position === 'fixed' && stickyRect.top < innerHeight
          ? Math.max(0, innerHeight - stickyRect.top)
          : 0;
        const topInset = topObstruction + 8;
        const bottomInset = bottomObstruction + 8;
        const purchaseTop = price.getBoundingClientRect().top + scrollY;
        const purchaseBottom = addButton.getBoundingClientRect().bottom + scrollY;
        let targetTop = Math.max(0, purchaseTop - topInset);
        const projectedPurchaseBottom = purchaseBottom - targetTop;
        const visibleBottom = innerHeight - bottomInset;
        if (projectedPurchaseBottom > visibleBottom) targetTop += projectedPurchaseBottom - visibleBottom;

        const focusVisibleControl = () => {
          const rect = listboxTrigger.getBoundingClientRect();
          if (rect.top >= topObstruction && rect.bottom <= innerHeight - bottomObstruction) {
            listboxTrigger.focus({ preventScroll: true });
          }
        };
        window.scrollTo({ top: targetTop, behavior });
        if (behavior === 'auto') {
          requestAnimationFrame(focusVisibleControl);
        } else {
          let lastY = scrollY;
          let stableFrames = 0;
          const startedAt = performance.now();
          const focusAfterScrollSettles = () => {
            const currentY = scrollY;
            stableFrames = Math.abs(currentY - lastY) < 0.5 ? stableFrames + 1 : 0;
            lastY = currentY;
            if (stableFrames >= 4 || performance.now() - startedAt > 5000) focusVisibleControl();
            else requestAnimationFrame(focusAfterScrollSettles);
          };
          requestAnimationFrame(focusAfterScrollSettles);
        }
        return;
      }

      const anchor = $('#PremaV6PurchaseAnchor') || listboxTrigger;
      if (!anchor || !listboxTrigger || !addButton) return;
      const header = $('#shopify-section-header');
      const sticky = $('#PremaV6Sticky');
      const headerRect = header?.getBoundingClientRect();
      const stickyRect = sticky?.getBoundingClientRect();
      const headerStyle = header ? getComputedStyle(header) : null;
      const stickyStyle = sticky ? getComputedStyle(sticky) : null;
      const topObstruction = headerRect && ['fixed', 'sticky'].includes(headerStyle?.position) && headerRect.bottom > 0
        ? Math.max(0, headerRect.bottom)
        : 0;
      const bottomObstruction = stickyRect && stickyStyle?.position === 'fixed' && stickyRect.top < innerHeight
        ? Math.max(0, innerHeight - stickyRect.top)
        : 0;
      const topInset = topObstruction + 12;
      const bottomInset = bottomObstruction + 12;
      const anchorTop = anchor.getBoundingClientRect().top + scrollY;
      const addBottom = addButton.getBoundingClientRect().bottom + scrollY;
      let targetTop = Math.max(0, anchorTop - topInset);
      const projectedAddBottom = addBottom - targetTop;
      const visibleBottom = innerHeight - bottomInset;
      if (projectedAddBottom > visibleBottom) targetTop += projectedAddBottom - visibleBottom;

      const focusVisibleControl = () => {
        const rect = listboxTrigger.getBoundingClientRect();
        if (rect.top >= topObstruction && rect.bottom <= innerHeight - bottomObstruction) {
          listboxTrigger.focus({ preventScroll: true });
        }
      };
      window.scrollTo({ top: targetTop, behavior });
      if (behavior === 'auto') {
        requestAnimationFrame(focusVisibleControl);
      } else {
        let lastY = scrollY;
        let stableFrames = 0;
        const startedAt = performance.now();
        const focusAfterScrollSettles = () => {
          const currentY = scrollY;
          stableFrames = Math.abs(currentY - lastY) < 0.5 ? stableFrames + 1 : 0;
          lastY = currentY;
          if (stableFrames >= 4 || performance.now() - startedAt > 5000) focusVisibleControl();
          else requestAnimationFrame(focusAfterScrollSettles);
        };
        requestAnimationFrame(focusAfterScrollSettles);
      }
    }
    $$('[data-pv6-scroll-buy]').forEach((button) => button.addEventListener('click', scrollToBuy));

    function initializeReviews() {
      const slides = $$('.review-slide');
      const count = $('#reviewCount');
      if (!slides.length) return;
      const show = (index) => {
        reviewIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== reviewIndex; });
        if (count) count.textContent = `${reviewIndex + 1} of ${slides.length}`;
      };
      $('#reviewPrev')?.addEventListener('click', () => show(reviewIndex - 1));
      $('#reviewNext')?.addEventListener('click', () => show(reviewIndex + 1));
      show(0);
    }

    function initializeLiveReviews() {
      const region = $('.pv6-live-reviews');
      if (!region) return;
      const hasVisibleReviewContent = () => Boolean(
        region.innerText.trim() ||
        region.querySelector('iframe,img,article,[role="listitem"],[data-testid]')
      );
      const syncVisibility = () => { region.hidden = !hasVisibleReviewContent(); };
      syncVisibility();
      new MutationObserver(syncVisibility).observe(region, { childList: true, subtree: true, characterData: true });
    }

    nativeSelect?.addEventListener('change', () => {
      const variant = variantById.get(nativeSelect.value);
      if (variant && variant.id !== selected.id) chooseVariant(variant, false, false, false);
    });

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!selected.available || addButton.disabled) return;
      errorNode.textContent = '';
      confirmation.hidden = true;
      addButton.disabled = true;
      addButton.textContent = 'Adding…';
      try {
        const payload = new FormData(form);
        payload.set('id', selected.id);
        payload.set('quantity', Math.max(1, Number(quantity.value) || 1));
        const response = await fetch(data.cartAddUrl + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: payload });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'This item could not be added.');
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((res) => res.json());
        cartMessage.textContent = `${selected.name} was added to your cart. Cart quantity: ${cart.item_count}.`;
        confirmation.hidden = false;
        $$('[data-cart-count],.cart-link__count,.header-cart__count').forEach((node) => { node.textContent = cart.item_count; node.hidden = false; });
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart, added: result } }));
      } catch (error) {
        errorNode.textContent = error.message || 'This item could not be added. Please try again.';
      } finally {
        addButton.disabled = !selected.available;
        addButton.textContent = selected.available ? `Add to Cart — ${selected.formattedPrice}` : 'Sold Out';
      }
    });

    document.addEventListener('keydown', (event) => {
      trapModalFocus(event);
      if (event.key !== 'Escape') return;
      closeListbox(false);
      if (activeModal && !activeModal.hidden) {
        event.preventDefault();
        closeModal(activeModal);
      }
    });

    renderHero();
    renderFamilyTabs();
    renderListbox();
    renderFamilyGallery();
    renderOverview();
    initializeReviews();
    initializeLiveReviews();
    updateSelectionUI(false, false, hasExplicitSelection);
  });
})();
